// Helper function to wrap an HTML structure around an element.
function wrap(el, wrapper) {
  el.parentNode.insertBefore(wrapper, el);
  wrapper.appendChild(el);
}

// Wrap textarea tables with .table-responsive.
document.addEventListener("DOMContentLoaded", function() {
  let newTable = document.createElement('div');
  newTable.className = 'table-responsive';
  wrap(document.querySelector('.text-area table'), newTable);
});
